import { TEXT } from "../../constants/text";
import ReadMoreContainer from "../ReadMoreContainer";

export default function Intro() {
  return (
    <>
      <h1
        className="pb-4
   display-1"
      >
        Tilsynserklæring
      </h1>
      <div className="row">
        <div className="col-12 col-xl-9">
          <ReadMoreContainer maxLength={9.5}>
            <p>{TEXT.intro.tilsyn_1}</p>
            <p>{TEXT.intro.tilsyn_2}</p>
            <h2
              className="display-4 fw-semibold"
              style={{ fontSize: "1.2rem" }}
            >
              Brugervejledning
            </h2>
            <ol className="my-3 ps-4">
              <li>
                <p className="ms-2 mb-2">
                  Du behøver ikke at udfylde hele erklæringen på én gang, men du
                  skal huske at klikke på "Gem ændringer", inden du forlader
                  siden, hvis du ønsker at gemme det, der er indtastet.
                </p>
              </li>
              <li>
                <p className="ms-2 mb-2">
                  Du kan give en anden person adgang til erklæringen fra sin
                  egen skærm, ved at kopiere og maile linket til erklæringen.
                  Klik på ”Invitér”.
                </p>
              </li>
              <li>
                <p className="ms-2 mb-2">
                  Ved at klikke på ”Forhåndsvisning” kan du se den samlede
                  erklæring, som den ser ud med de oplysninger, der indtil
                  videre er indtastet.
                </p>
              </li>
              <li>
                <p className="ms-2 mb-2">
                  Erklæringen bliver først sendt til Advokatsamfundet, når den
                  er MitID-godkendt af dig. Som advokat kan du kun
                  MitID-godkende erklæringen, når du er logget ind med MitID, og
                  altså ikke via et link.
                </p>
              </li>
              <li>
                <p className="ms-2 mb-2">
                  Du modtager en mail med den samlede erklæring i forbindelse
                  med indsendelsen, hvis du har indtastet en mailadresse til
                  brug herfor.
                </p>
              </li>
            </ol>
          </ReadMoreContainer>
        </div>
      </div>
    </>
  );
}
